export enum EHeatmapLoadingKey {
  HEATMAP_CLICK = 'HEATMAP_CLICK',
  HEATMAP_SCROLL = 'HEATMAP_SCROLL',
  ANALYTICS = 'ANALYTICS',
  CLICK_ELEMENT = 'CLICK_ELEMENT',
  SNAPSHOT_DOM = 'SNAPSHOT_DOM',
  LIST_SNAPSHOTS = 'LIST_SNAPSHOTS',
  AUTH = 'AUTH',
}
